export default __webpack_public_path__ + "static/media/left.8b912f94.svg";